import { render, staticRenderFns } from "./NarliFerryboatStatsByVehicleTypeSummaryGraph.vue?vue&type=template&id=c2c5993a&"
import script from "./NarliFerryboatStatsByVehicleTypeSummaryGraph.vue?vue&type=script&lang=js&"
export * from "./NarliFerryboatStatsByVehicleTypeSummaryGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports